import HTTPService from '../HTTPService'

class Client {
  getAll (companySlug, page = 1, search = '', tags = '') {
    const params = `?page=${page}${search ? `&search=${search}` : ''}${tags ? `&tags=${tags}` : ''}`

    return HTTPService.get(`company/${companySlug}/client${params}`)
  }

  getOne (companySlug, clientId) {
    return HTTPService.get(`company/${companySlug}/client/${clientId}`)
  }

  updateOne (companySlug, clientId, payload) {
    return HTTPService.put(`company/${companySlug}/client/${clientId}`, {
      name: payload.name,
      description: payload.description,
      tags: payload.tags || []
    })
  }

  transferTo (companySlug, clientId, payload) {
    return HTTPService.post(`company/${companySlug}/client/${clientId}/assign-session`, {
      email: payload.email
    })
  }

  closeSession (companySlug, clientId) {
    return HTTPService.post(`company/${companySlug}/client/${clientId}/close-session`)
  }

  exportHistory (companySlug, clientId) {
    return HTTPService.post(`company/${companySlug}/client/${clientId}/export`)
  }
}

export default new Client()
